import { ColorIcon } from "./icon/color";
import { FingerIcon } from "./icon/finger";
import { GargenIcon } from "./icon/garden";
import { ClipIcon } from "./icon/clip";
import { HomeIcon } from "./icon/home";
import { MoneyIcon } from "./icon/money";
import { SettingsIcon } from "./icon/settings";
import { ToolsIcon } from "./icon/tools";
import { WarningIcon } from "./icon/warning";

const services = [
  {
    title: "صيانة العقارات",
    detailes:
      "يتم توفير خدمات عالية الجودة بأسعار تنافسية. تسعى الشركة لتحقيق رضا العملاء من خلال تلبية احتياجاتهم وتقديم حلول فعالة وفي الوقت المناسب. إذا كنت تبحث عن خدمات صيانة العقارات، يمكنك التواصل مع شركة أوشن فيو للحصول على استشارة وعرض سعر مجاني.",
  },
  {
    title: "الادارة القانونية",
    detailes:
      "لقد قامت الشركة بالتعاقد مع شركات محاماة ذات خبرة ومؤهلة في مجال قانون العقارات وقضايا التعثرات المالية. تهدف هذه الشركات إلى تقديم المشورة القانونية والخدمات القانونية المتعلقة بإدارة العقارات والتعثرات المالية بشكل فعال وفي إطار القوانين المحلية.",
  },
];
const lawServices = [
  {
    title: "صيانة العقارات",
    detailes:
      "يتم توفير خدمات عالية الجودة بأسعار تنافسية. تسعى الشركة لتحقيق رضا العملاء من خلال تلبية احتياجاتهم وتقديم حلول فعالة وفي الوقت المناسب. إذا كنت تبحث عن خدمات صيانة العقارات، يمكنك التواصل مع شركة أوشن فيو للحصول على استشارة وعرض سعر مجاني.",
  },
  {
    title: "الادارة القانونية",
    detailes:
      "لقد قامت الشركة بالتعاقد مع شركات محاماة ذات خبرة ومؤهلة في مجال قانون العقارات وقضايا التعثرات المالية. تهدف هذه الشركات إلى تقديم المشورة القانونية والخدمات القانونية المتعلقة بإدارة العقارات والتعثرات المالية بشكل فعال وفي إطار القوانين المحلية.",
  },
];
export const MoreServices = () => {
  return (
    <div
      id="services"
      class="mx-auto  max-w-7xl px-6 sm:mt-40 lg:px-8 relative"
    >
      <div
        class="absolute  inset-x-0 -top-90 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-96"
        aria-hidden="true"
      >
        <div
          class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#97cbd4a4] to-[#5d94e68e] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        ></div>
      </div>{" "}
      <div>
        <div class="mx-auto max-w-2xl lg:mx-0 ">
          <h2 class="text-xl font-bold tracking-tight text-gray-700 sm:text-2xl">
            خدمات شركات المحاماة
          </h2>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            لقد قامت الشركة بالتعاقد مع شركات محاماة ذات خبرة ومؤهلة في مجال
            قانون العقارات وقضايا التعثرات المالية. تهدف هذه الشركات إلى تقديم
            المشورة القانونية والخدمات القانونية المتعلقة بإدارة العقارات
            والتعثرات المالية بشكل فعال وفي إطار القوانين المحلية.
          </p>
        </div>
        <dl class="max-w-2xl flex flex-col mx-auto mt-8  lg:mx-0  leading-7">
          <h3 className="py-1 text-xl font-semibold text-gray-600">
            تشمل خدمات الشركات المحاماة التي تم التعاقد معها ما يلي:
          </h3>
          <ul className="flex flex-col gap-1 text-gray-500 text-md list-disc ms-6">
            <li>
              استعراض وتحليل العقود القانونية المتعلقة بالعقارات والمستأجرين
              والملاك.
            </li>

            <li>
              توفير المشورة القانونية والتوجيه فيما يتعلق بأية قضايا قانونية
              تنشأ في سياق إدارة العقارات.
            </li>
            <li>
              معالجة وإنهاء التعثرات المالية قانونياً، بما في ذلك استعادة الديون
              العالقة من الجهات المدينة وتنفيذ أي إجراءات قضائية إذا لزم الأمر.
            </li>
            <li>
              متابعة أي قضايا قانونية تنشأ بشأن العقارات مثل المستأجرين العاطلين
              عن الدفع أو التعدي على حقوق الملكية.{" "}
            </li>
          </ul>
          <p className="text-gray-700 text-md py-1">
            بالاعتماد على التعاقد مع شركات المحاماة المؤهلة وذات الخبرة، تسعى
            شركة أوشن فيو العقارية إلى ضمان الامتثال للقوانين واللوائح المحلية
            والتخلص من أي تعقيدات قانونية قد تواجهها في إدارة العقارات والتعثرات
            المالية.
          </p>
        </dl>{" "}
      </div>
      <div>
        <div class="mx-auto max-w-2xl lg:mx-0 mt-12">
          <h2 class="text-xl font-bold tracking-tight text-gray-700 sm:text-2xl">
            الإدارة والحسابات
          </h2>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            وجود محاسبين في شركة أوشن فيو العقارية ضروري لأداء العديد من المهام
            المالية والمحاسبية المتعلقة بإدارة العقارات. يقوم المحاسبون في
            الشركة بإصدار القوائم المالية ومراقبة التكاليف التشغيلية والمصروفات
            المتعلقة بالعقارات.
          </p>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            بالإضافة إلى ذلك، يقوم المحاسبون بتحليل الإيرادات والأرباح المتحققة
            من العقارات وتحضير تقارير مالية شاملة. يتم ذلك من خلال تقييم أداء
            الوحدات والمرافق السكنية والتجارية وتحليل تكاليف الصيانة والتشغيل
            والإيرادات المتعلقة بها.
          </p>
        </div>
        <dl class="max-w-2xl flex flex-col mx-auto mt-8  lg:mx-0   leading-7">
          <h3 className="py-1 text-xl font-semibold text-gray-600">
            بشكل عام، يشتمل الدور الرئيسي للمحاسبين في شركة أوشن فيو العقارية
            على:
          </h3>
          <ul className="flex flex-col gap-1 text-gray-500 text-md list-disc ms-6">
            <li>إعداد القوائم المالية الشهرية والسنوية للعقارات.</li>

            <li>
              مراقبة التكاليف التشغيلية والمصروفات لضمان تحقيق العقارات للأرباح
              المستهدفة.
            </li>
            <li>
              تحليل الإيرادات والأرباح المحققة من العقارات وتقديم تقارير شاملة
              بهذا الشأن.
            </li>
            <li>
              إعداد وتحليل عروض السعر لوحدات العقارات المستأجرة والمبيعات
              المحتملة.
            </li>
            <li>
              التعامل مع المشكلات المحاسبية وحلها وتقديم النصح والاستشارة
              المالية للشركة.
            </li>
          </ul>
          <p className="text-gray-700 text-md py-1">
            باختصار، يعمل المحاسبون في شركة أوشن فيو العقارية على ضمان تحقيق
            الأهداف المالية للشركة من خلال إدارة وتحليل البيانات المالية
            المتعلقة بالعقارات وإعداد تقارير مالية شاملة للوحدات والمرافق
            السكنية والتجارية.
          </p>
        </dl>{" "}
      </div>
      <div>
        <div class="mx-auto max-w-2xl lg:mx-0 mt-12">
          <h2 class="text-xl font-bold tracking-tight text-gray-700 sm:text-2xl">
            التسويق والتاجير والبيع والشراء
          </h2>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            شركة اوشن فيو العقارية تعمل في مجال تسويق الوحدات العقارية بطرق
            متعددة وفعّالة. تسعى الشركة إلى رفع القيمة السوقية للعقارات التي
            تتعامل معها وتحقيق أعلى عائد ممكن سواء من خلال عمليات البيع أو
            التأجير السكني أو التجاري.
          </p>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            تعتمد شركة اوشن فيو العقارية على استخدام الشبكات الاجتماعية
            والعلاقات العامة لتسويق الوحدات العقارية بشكل شامل. تقوم الشركة
            ببناء علاقات موثوقة مع العملاء والشركاء في السوق العقارية من خلال
            حضور المعارض والفعاليات ذات الصلة، وتنظيم جلسات تعريفية وعروض
            تقديمية للمستثمرين والمشترين المحتملين.
          </p>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            بالإضافة إلى ذلك، تقوم شركة اوشن فيو بتسجيل قوائم العقارات في
            القواعد البيانات المحلية والعالمية المتخصصة، مما يزيد من فرصة جذب
            العملاء وزيادة الوعي بالعقارات المتاحة للبيع أو التأجير.
          </p>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            تهتم الشركة بتحسين قيمة العقارات المتاحة للتسويق عن طريق تطبيق
            استراتيجيات التسويق المبتكرة والفعّالة. تقوم بتصميم حملات تسويق
            متكاملة، تشمل الاعلانات التلفزيونية والإعلانات الإلكترونية والتسويق
            عبر وسائل التواصل الاجتماعي والمواقع الإلكترونية المخصصة.
          </p>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            بالإضافة إلى ذلك، تقوم شركة اوشن فيو بتوفير خدمات استشارية لتحقيق
            أعلى عائد ممكن عن طريق تحليل السوق وتقييم العقارات وضبط أسعارها
            وتوجيه العملاء بشكل استراتيجي للبيع أو التأجير.
          </p>
        </div>
      </div>
      <div>
        <div class="mx-auto max-w-2xl lg:mx-0 mt-12">
          <h2 class="text-xl font-bold tracking-tight text-gray-700 sm:text-2xl">
            خدمات إدارة العقارات
          </h2>
          <p class="mt-6 text-lg leading-8 text-gray-600">
            اوشن فيو تتميز بفريق عمل متخصص ومجهز بأحدث التقنيات لضمان تحقيق أعلى
            مستويات الخدمة للمستأجرين وتسهيل عملية السداد
          </p>
        </div>
        <dl class="max-w-2xl  flex flex-col mx-auto mt-8  lg:mx-0   leading-7">
          {/* <h3 className="py-1 text-xl font-semibold text-gray-600">
            بشكل عام، يشتمل الدور الرئيسي للمحاسبين في شركة أوشن فيو العقارية
            على:
          </h3> */}
          <ul className="flex flex-col gap-2 text-gray-500 text-md list-disc ms-6">
            <li>
              <span className="text-gray-800">
                "فريق العمل المحترف والتقنيات الحديثة في خدمتك":
              </span>
              <p className="text-gray-500 text-md py-1">
                نحن في شركة أوشن فيو العقارية نعتبر فريق العمل المحترف والمجهز
                بأحدث التقنيات جزءًا أساسيًا من نجاح خدمات إدارة العقارات لدينا.
                يتابع فريق العمل المستأجرين بعناية فائقة ويسهل عملية السدادات
                بفضل التقنيات الحديثة، مما يوفر لك تجربة استئجار عقارية سلسة
                ومريحة.
              </p>
            </li>
            <li>
              <span className="text-gray-800">"تقارير شاملة لكل حالة":</span>
              <p className="text-gray-500 text-md py-1">
                فريقنا المتخصص يقوم بكتابة تقارير مفصلة عن حالة كل مستأجر، مما
                يساعد في توثيق وتسجيل جميع الأحداث والتفاصيل المهمة. عندما يتعلق
                الأمر بالمستأجرين، يتم متابعة كل تفاصيل المدفوعات وتأكيد
                استلامها، مما يوفر لك رؤية شاملة لأداء ممتلكاتك العقارية.
              </p>
            </li>
            <li>
              <span className="text-gray-800">"جودة وشفافية في الخدمة":</span>
              <p className="text-gray-500 text-md py-1">
                تعتبر جودة الخدمة وشفافية المعاملات أولوية بالنسبة لنا في شركة
                أوشن فيو العقارية. نضمن لك تلقي تقارير منتظمة ومفصلة بشأن حالة
                المستأجرين والسدادات، مما يمنحك أعلى مستويات المعرفة والثقة في
                أداء عقاراتك.
              </p>
            </li>
            <li>
              <span className="text-gray-800">
                "تواصل فعال واستجابة سريعة":
              </span>
              <p className="text-gray-500 text-md py-1">
                كفريق عمل متفاني في تقديم أعلى مستويات الخدمة، نحرص على توفير
                تواصل فعال واستجابة سريعة في تقديم تقارير مالية مفصله
              </p>
            </li>
          </ul>
        </dl>{" "}
      </div>
    </div>
  );
};
